const constraints = {
  CONTACT_NM_REGEX: /^(?![ ,._-])(?!.*[ ,._-]$)[\w ,.-]+$/,
  CONTACT_NM_MAX: 30,
  CONTACT_NM_MIN: 6,

  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!#$%*@^_-])([\w!#$%*@^-])+$/,
  PASSWORD_COMMON_REGEX: /^(?!.*(([Aa|][Mm|][Ee|][Xx|])|([Qq|][Ww|][Ee|][Rr|][Tt|][Yy|])|([Pp|][Aa|][Ss|]{2}[Ww|][Oo|][Rr|][Dd|])|([Aa|][Bb|][Cc|])|([Pp|]@[Ss|]{2}[Ww|][Oo|][Rr|][Dd|]))).*$/,
  PASSWORD_MAX: 40,
  PASSWORD_MIN: 8,
};

export default constraints;
